import React, { useEffect, useRef, useState } from "react";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import formatDateAndTime from "../../common/formatDateAndTime";
import toast from "react-hot-toast";
import CachedIcon from '@mui/icons-material/Cached';

const Comments = ({
  setBookingComments,
  bookingComments,
  getBookingComments,
  summaryDetails,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const profile = JSON.parse(localStorage.getItem("profile"));
  // const [bookingComments, setBookingComments] = useState([]);
  const [comment, setComment] = useState(null);
  const fileInputRef = useRef(null);
  const [imageData, setImageData] = useState(null);
  const [image, setImage] = useState(null);

  const handleClick = () => {
    fileInputRef.current.click();
  };
  

  // useEffect(() => {
  //   if (summaryDetails?.id) {
  //     getBookingComments(summaryDetails?.id);
  //   }
  // }, [summaryDetails]);

  // const getBookingComments = async (id) => {
  //   try {
  //     const response = await fetch(
  //       `${apiUrl}/api/bookingcomments?limit=1000&bookingId=${id}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Accept: "application/json",
  //         },
  //       },
  //     );
  //     const data = await response.json();
  //     if (data?.statusCode === "0100") {
  //       const sorted = data?.entities?.rows.sort(
  //         (a, b) => new Date(a.createdAt) - new Date(b.createdAt), // oldest → newest
  //       );
  //       setBookingComments(sorted);
  //     }
  //     return data;
  //   } catch (error) {
  //     return console.error("Error fetching Users List:", error);
  //   }
  // };

  const postComment = async (id) => {
    if (!comment) {
      return toast.error("Please enter comment", {
        position: "bottom-center",
        style: {
          background: "white", // override background
          color: "red",
          fontWeight: "medium",
        },
      });
    }
    try {
      const response = await fetch(`${apiUrl}/api/bookingcomments`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          comment: comment,
          bookingId: summaryDetails?.id,
          commentedBy: profile?.name,
          emailId: profile?.email,
          attachments: imageData ? JSON.stringify(imageData) : null,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setComment("");
        setImageData(null);
        setImage(null);
        await getBookingComments(summaryDetails?.id);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Users List:", error);
    }
  };

  const attachmentUpload = async (event) => {
    const files = event.target.files;
    const formData = new FormData();
    formData.append("entityName", "vehicles");
    formData.append("fileTags", "booking-comments");
    Object.values(files).forEach((file) => {
      formData.append("files", file);
    });

    try {
      const response = await fetch(`${apiUrl}/fileapi/upload`, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data) {
        setImageData(data?.uploaded);
        setImage(data?.uploaded[0]?.url);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const getAttachmentList = (value) => {
    if (!value) return [];
    if (typeof value === "string") {
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch (e) {
        return [];
      }
    }
    if (Array.isArray(value)) {
      return value;
    }
    return [value];
  };

  const getAttachmentUrl = (attachment) => {
    if (!attachment) return "";
    if (typeof attachment === "string") return attachment;
    return attachment?.url || attachment?.path || attachment?.fileUrl || attachment?.downloadUrl || "";
  };

  const getAttachmentName = (attachment, index) => {
    if (!attachment) return `Attachment ${index + 1}`;
    if (typeof attachment === "string") {
      return attachment.split("/").pop() || `Attachment ${index + 1}`;
    }
    return (
      attachment?.name ||
      attachment?.fileName ||
      attachment?.originalName ||
      `Attachment ${index + 1}`
    );
  };

  const getAttachmentType = (attachment) => {
    const url = getAttachmentUrl(attachment);
    const fileName = getAttachmentName(attachment, 0).toLowerCase();
    const source = `${url} ${fileName}`;

    if (/\.(png|jpe?g|gif|webp|svg|bmp|heic|heif)$/i.test(source)) {
      return "image";
    }
    if (/\.pdf$/i.test(source)) {
      return "pdf";
    }
    if (/\.(mp4|webm|ogg|mov|avi|mkv)$/i.test(source)) {
      return "video";
    }
    if (/\.(doc|docx|xls|xlsx|ppt|pptx|txt|csv|zip|rar)$/i.test(source)) {
      return "document";
    }
    return "file";
  };

  return (
    <div>
      <div className="flex flex-col h-screen bg-gray-50">
        <div className="p-4 border-b bg-white shadow-sm flex justify-between">
          <h2 className="text-lg font-semibold">
            Inquiry Id - {summaryDetails?.inquiryCode || "N/A"}
          </h2>
          <h2 className="text-lg font-semibold">
            <span onClick={() => {getBookingComments(summaryDetails?.id)}} className="bg-green-400 cursor-pointer p-2 rounded-full"><CachedIcon/></span>
            Booking Id - {summaryDetails?.bookingCode || "N/A"}
          </h2>
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-6">
          <div className="flex items-center justify-center">
            <span className="text-sm text-gray-500 px-4 py-1 bg-gray-200 rounded-full">
              {new Date().toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </span>
          </div>

          {bookingComments && bookingComments.length > 0 ? (
            bookingComments.map((message, index) => {
              const isMyComment = message?.commentedBy === profile?.name;

              const attachments = getAttachmentList(message?.attachments);

              return (
                <div
                  key={index}
                  className={`flex flex-col ${
                    isMyComment ? "items-end" : "items-start"
                  }`}
                >
                  <div
                    className={`px-4 py-3 rounded-lg shadow text-white w-fit max-w-[30%] break-words whitespace-pre-wrap ${
                      isMyComment
                        ? "bg-blue-500 rounded-br-none self-end"
                        : "bg-gray-500 rounded-bl-none self-start"
                    }`}
                  >
                    {attachments.length > 0 && (
                      <div className="mb-3 space-y-2">
                        {attachments.map((attachment, attachIndex) => {
                          const attachmentUrl = getAttachmentUrl(attachment);
                          const attachmentName = getAttachmentName(
                            attachment,
                            attachIndex,
                          );
                          const attachmentType = getAttachmentType(attachment);

                          return (
                            <div
                              key={`${attachmentName}-${attachIndex}`}
                              className="rounded-md border border-white/30 bg-white/10 p-2"
                            >
                              {attachmentType === "image" && attachmentUrl ? (
                                <img
                                  src={attachmentUrl}
                                  alt={attachmentName}
                                  className="max-w-xs w-48 h-44 rounded object-cover mb-2"
                                />
                              ) : attachmentType === "video" && attachmentUrl ? (
                                <video
                                  controls
                                  className="max-w-xs w-48 h-44 rounded mb-2 bg-black"
                                >
                                  <source src={attachmentUrl} />
                                </video>
                              ) : (
                                <div className="mb-2 rounded border border-white/20 bg-white/90 p-2 text-gray-800">
                                  <p className="text-sm font-medium truncate">
                                    {attachmentName}
                                  </p>
                                  <p className="text-xs text-gray-500">
                                    {attachmentType === "pdf"
                                      ? "PDF document"
                                      : attachmentType === "document"
                                      ? "Document file"
                                      : "File attachment"}
                                  </p>
                                </div>
                              )}

                              <a
                                href={attachmentUrl}
                                target="_blank"
                                rel="noreferrer"
                                download={attachmentName}
                                className="inline-flex items-center rounded-full bg-white/20 px-2.5 py-1 text-xs font-semibold text-white hover:bg-white/30"
                              >
                                Download
                              </a>
                            </div>
                          );
                        })}
                      </div>
                    )}
                    {message?.comment}
                  </div>

                  <div
                    className={`text-xs text-gray-700 mt-1 ${
                      isMyComment ? "text-right" : "text-left"
                    }`}
                  >
                    Created By: {message?.commentedBy}{" "}
                    {formatDateAndTime(message?.updatedAt)}
                  </div>
                </div>
              );
            })
          ) : (
            <h1 className="text-center mx-auto mt-10">No Booking Comments</h1>
          )}
        </div>

        <div className="p-4 border-t bg-white flex items-center gap-2">
          {image && (
            <div>
              <img src={image} className="h-44 w-44" />
            </div>
          )}
          <div className="flex items-center">
            <input
              type="file"
              ref={fileInputRef}
              className="hidden"
              onChange={(event) => {
                attachmentUpload(event);
              }}
            />

            <button
              type="button"
              onClick={handleClick}
              className="p-2 rounded-full hover:bg-gray-200"
            >
              <AttachFileIcon />
            </button>
          </div>

          <input
            type="text"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault(); // avoid adding a newline
                postComment(); // call send function
              }
            }}
            placeholder="Type a message..."
            className="flex-1 border rounded-full px-4 py-2 h-14 focus:outline-none focus:ring-2 focus:ring-blue-400"
          />

          <button
            onClick={postComment}
            type="submit"
            className="flex justify-center gap-2 items-center mx-auto shadow-xl text-lg bg-gray-50 backdrop-blur-md lg:font-semibold isolation-auto border-gray-50 before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-left-full before:hover:left-0 before:rounded-full before:bg-emerald-500 hover:text-gray-50 before:-z-10 before:aspect-square before:hover:scale-150 before:hover:duration-700 relative z-10 px-4 py-2 overflow-hidden border-2 rounded-full group"
          >
            Sent
            <svg
              className="w-8 h-8 justify-end group-hover:rotate-90 group-hover:bg-gray-50 text-gray-50 ease-linear duration-300 rounded-full border border-gray-700 group-hover:border-none p-2 rotate-45"
              viewBox="0 0 16 19"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                className="fill-gray-800 group-hover:fill-gray-800"
              ></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Comments;
